import { afterNextRender, Component, ElementRef, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { MatDialog } from '@angular/material/dialog';
import { SharedModule } from '../../shared/shared.module';
import { NotificationSettingsDataService } from '../../services/data/notification-settings-data.service';
import { EditNotificationSettingsDialogComponent } from '../dialogs/edit-notification-settings-dialog/edit-notification-settings-dialog.component';
import { notificationChannels } from '../notification-channels';

@Component({
  selector: 'app-notification-settings-card',
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatListModule,
    SharedModule,
  ],
  templateUrl: './notification-settings-card.component.html',
  styleUrl: './notification-settings-card.component.scss',
})
export class NotificationSettingsCardComponent {
  protected readonly data = inject(NotificationSettingsDataService);
  private readonly dialog = inject(MatDialog);
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly route = inject(ActivatedRoute);
  protected readonly channels = notificationChannels;

  constructor() {
    this.data.load();
    afterNextRender(() => {
      if (this.route.snapshot.fragment !== 'notification-settings') return;
      this.host.nativeElement.scrollIntoView({ block: 'center' });
      this.host.nativeElement
        .querySelector<HTMLElement>('#notification-settings-title')
        ?.focus({ preventScroll: true });
    });
  }

  protected edit(): void {
    const settings = this.data.settings();
    if (!settings) return;
    this.dialog.open(EditNotificationSettingsDialogComponent, {
      width: '38rem',
      maxWidth: '95vw',
      data: settings,
    });
  }
}
